import type { Lang, SiteCopy } from './types';

export type { Lang, SiteCopy };
import zh from './zh';
import en from './en';

export const LANG_STORAGE_KEY = 'unitestream-lang';
export const COOKIE_CONSENT_KEY = 'unitestream-cookie-consent';

const bundles: Record<Lang, SiteCopy> = { zh, en };

export const DEFAULT_LANG: Lang = 'en';

export function getCopy(lang: Lang): SiteCopy {
  return bundles[lang];
}

export function langFromSearch(): Lang | null {
  if (typeof location === 'undefined') return null;
  const param = new URLSearchParams(location.search).get('lang');
  if (param === 'zh' || param === 'en') return param;
  return null;
}

export function storedLang(): Lang | null {
  if (typeof localStorage === 'undefined') return null;
  const value = localStorage.getItem(LANG_STORAGE_KEY);
  return value === 'zh' || value === 'en' ? value : null;
}

export function persistLang(lang: Lang): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(LANG_STORAGE_KEY, lang);
}

function browserPrefersChinese(): boolean {
  if (typeof navigator === 'undefined') return false;
  const langs = [...(navigator.languages ?? []), navigator.language]
    .filter(Boolean)
    .map((l) => l.toLowerCase());
  return langs.some((l) => l.startsWith('zh'));
}

export function detectLang(): Lang {
  const fromUrl = langFromSearch();
  if (fromUrl) return fromUrl;
  const saved = storedLang();
  if (saved) return saved;
  if (browserPrefersChinese()) return 'zh';
  return DEFAULT_LANG;
}

export function syncLangInUrl(lang: Lang): void {
  if (typeof history === 'undefined' || typeof location === 'undefined') return;
  const url = new URL(location.href);
  if (lang === 'zh') url.searchParams.set('lang', 'zh');
  else url.searchParams.delete('lang');
  history.replaceState(null, '', url);
}

export function setLang(lang: Lang): void {
  document.documentElement.lang = lang === 'zh' ? 'zh-CN' : 'en';
}

export function t(lang: Lang): SiteCopy {
  return getCopy(lang);
}
